import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../../assets/images/pac-iq-logo.svg';
import styles from './PacIqLogo.module.css';

export type PacIqLogoProps = LayoutNavComponentProps;

export function PacIqLogo({ transparent }: PacIqLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<SvgFromUrl
				url={logoSvg}
				height={'21px'}
				className={classNames(styles['logo'], {
					[styles['transparent']]: transparent,
				})}
			/>
		</TrackingLink>
	);
}
